import React, { Component } from "react";
import Countries from "../../services/countries.service";
import Select from 'react-select';
// import DropDownIcon from "../../assets/img/GreyArrowDown.svg";
import DropDownIcon from "../../assets/img/MenuDropdown.svg";

import Translation from "../../services/translation.service";

export default class CountrySelectTag extends Component {
    state = {
        selected_country: null,
        isOpen: false,
    };

    customStylesSelect = {
        control: (provided) => {
            return {
                ...provided,
                background: "transparent",
                color: "#404040",
                fontSize: "16px",
                cursor: "pointer",
                fontWeight: "500",
                minHeight: "44px",
                width: "220px",
                borderRadius: "10px 10px 0px 0px",
                borderTop: "1px solid #898D9A",
                borderRight: "1px solid #898D9A",
                borderLeft: "1px solid #898D9A",
                padding: "0px 5px",
            }
        },
        menu: (provided) => ({
            ...provided,
            width: "220px",
            borderRadius: "0px 0px 10px 10px",
            border: "1px solid #898D9A",
            padding: "0px 5px",
            background: "#ffffff",
        }),
        option: (provided, state) => {
            return {
                ...provided,
                fontStyle: "normal",
                fontWeight: 400,
                fontSize: "15px",
                lineHeight: "20px",
                color: state.isSelected ? "#404040" : "#404040",
                cursor: "pointer",
                paddingTop: "5px",
                paddingBottom: "5px",
                paddingRight: "5px",
                backgroundColor: "#ffffff",
                borderTop: "1px solid #898D9A",
                "&:first-of-type": {
                    borderTop: "none"
                },
                ".country-option-label": {
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    img: {
                        aspectRatio: 3 / 2,
                        maxHeight: "20px"
                    },
                    "& > div": {
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        margin: "0px 5px",
                    }
                },
                "&:hover": !state.isSelected ? {
                    backgroundColor: "#e10a0a",
                    color: "#ffffff",
                } : {}
            }
        },
    }

    countries = Countries.Countries;
    country_codes = Countries.sortedCountryCodes;
    countries_list = [];

    componentDidMount() {
        this.setState({
            selected_country: this.props.defaultCountry,
            disabled: this.props.disabled
        });
    }

    constructor() {
        super();
        for (var i = 0; i < this.country_codes.length; i++) {
            this.countries_list.push(
                {
                    value: this.countries[this.country_codes[i]].CountryName,
                    flagCode: this.countries[this.country_codes[i]].ISO_2Code,
                    countryCode: this.countries[this.country_codes[i]].CountryCode,
                    label: (
                        <div className="country-option-label">
                            <img src={this.getFlag(this.countries[this.country_codes[i]].ISO_2Code)} alt={this.countries[this.country_codes[i]].ISO_2Code} />
                            <div>
                                {this.countries[this.country_codes[i]].CountryName}
                                <span>
                                    ({this.countries[this.country_codes[i]].CountryCode})
                                </span>
                            </div>
                        </div>
                    )
                }
            );
        }
    }


    getFlag = (code) => {
        let flag = require("../../assets/img/flags/" +
            code.toUpperCase() +
            ".png");
        return flag;
    }

    selectCountry(event) {
        this.setState({
            selected_country: event.flagCode,
            isOpen: false,
        });
        let iso = event.countryCode;
        this.props.updateFieled(event.flagCode, iso);
    }

    SingleValue = ({ data }) => {
        return (
            <div className="storefront-country-selected">
                <img src={this.getFlag(data.flagCode)} alt={data.flagCode} />
                {data.countryCode}
            </div>
        );
    };

    render() {
        let country_select = "";
        let list = this.countries_list;
        if (this.state.selected_country) {
            country_select = (
                <div style={{ height: "100%" }}>
                    <Dropdown
                        isOpen={this.state.isOpen}
                        onClose={() => this.setState({
                            isOpen: false,
                        })}
                        target={
                            <div
                                onClick={() => {
                                    if (!this.props.disabled) {
                                        this.setState({
                                            isOpen: true,
                                        })
                                    }
                                }
                                }
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: "100%",
                                    height: "100%",
                                    cursor: this.props.disabled ? "unset" : "pointer"
                                }}
                            >
                                <div className="storefront-country-selected">
                                    <img src={this.getFlag(this.state.selected_country)} alt={this.state.selected_country} />
                                    {this.countries[this.state.selected_country].CountryCode}
                                </div>
                                {this.state.disabled ? null :
                                    <img src={DropDownIcon} alt="" style={{ margin: "0px 8px" }} />}
                            </div>
                        }
                    >
                        <Select
                            unstyled
                            autoFocus
                            backspaceRemovesValue={false}
                            controlShouldRenderValue={false}
                            hideSelectedOptions={false}
                            isClearable={false}
                            menuIsOpen
                            placeholder={Translation.keys["scr_protection_channel_select"]}
                            tabSelectsValue={false}
                            defaultValue={{
                                value: this.countries[this.state.selected_country].CountryName,
                                flagCode: this.state.selected_country,
                                countryCode: this.countries[this.state.selected_country].CountryCode,
                                label: (
                                    <div className="country-option-label">
                                        <img src={this.getFlag(this.state.selected_country)} alt={this.state.selected_country} />
                                        <div>
                                            {this.countries[this.state.selected_country].CountryName}
                                            <span>{this.countries[this.state.selected_country].CountryCode}</span>
                                        </div>
                                    </div>
                                )
                            }}
                            onChange={e => this.selectCountry(e)}
                            options={list}
                            styles={this.customStylesSelect}
                            components={{ SingleValue: this.SingleValue, IndicatorSeparator: null, DropdownIndicator: null, NoOptionsMessage: () => <div className="no-country-records">-</div> }}
                        />
                    </Dropdown>
                </div>
            );
        }

        return country_select;
    }
}

const Dropdown = ({ children, isOpen, target, onClose }) => (
    <div style={{
        position: 'relative',
        display: "flex",
        height: "100%",
        alignItems: "center",
        justifyContent: "center",
    }}>
        {target}
        {isOpen ? <Menu>{children}</Menu> : null}
        {isOpen ? <Blanket onClick={onClose} /> : null}
    </div>
);

const Menu = (props) => (
    <div
        style={{
            backgroundColor: 'white',
            borderRadius: "10px 10px 0px 0px",
            position: 'absolute',
            zIndex: 2,
            top: "-1px",
            left: "-1px",
        }}
        {...props}
    />
);

const Blanket = (props) => (
    <div
        style={{
            bottom: 0,
            left: 0,
            top: 0,
            right: 0,
            position: 'fixed',
            zIndex: 1,
        }}
        {...props}
    />
);